


































































import Vue from 'vue';
import { mapState } from 'vuex';
import SideMenu from '@/components/SideMenu.vue';
import PageFooter from '@/components/PageFooter.vue';

export default Vue.extend({
    name: 'App',

    components: {
        PageFooter,
        SideMenu,
    },

    data() {
        return {
            drawer: null,
        };
    },

    computed: {
        ...mapState(['showLoader', 'snackbar']),

        headerTitle() {
            if (this.$store.state.headerTitle) {
                return this.$store.state.headerTitle;
            }

            if (this.$route.meta.headerTitle) {
                return this.$route.meta.headerTitle;
            }

            return null;
        },
    },

    watch: {
        $route(newRoute) {
            this.$store.commit('setHeaderTitle', null);
            document.body.setAttribute('data-route', newRoute.name);
        },
    },
});
